module.exports = __webpack_public_path__ + "static/babyaccessories-cbad041a226847fe5cc2233da27e35b9.jpeg";